"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSchemaCall = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const getSchemaCall = async url => {
  try {
    return await (0, _axios.default)({
      method: "get",
      url: url,
      headers: {
        "Content-Type": "application/json"
      }
    });
  } catch (e) {
    throw e;
  }
};
exports.getSchemaCall = getSchemaCall;